import React, { useEffect, useState } from "react";
import { Card, Spin } from "antd";
import youtube from "../utils/youtube";
import moment from "moment";

const { Meta } = Card;

const PlaylistList = ({ googleMeetsLink, playlistId }) => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedVideo, setSelectedVideo] = useState(null);

    // const playlistId = "PLPgQ__36nJyUCOlZeBSGcK3FAAnQTC3qa"; // Replace with your playlist ID

    const fetchVideos = async (playlistId) => {
        try {
            const response = await youtube.get("/playlistItems", {
                params: {
                    part: "snippet",
                    maxResults: 10,
                    playlistId: playlistId,
                },
            });

            const videoData = response.data.items.map((item) => ({
                id: item.snippet.resourceId.videoId,
                title: item.snippet.title,
                thumbnail: item.snippet.thumbnails.medium.url,
                publishedAt: moment(item.snippet.publishedAt).format("ddd, DD MMM YYYY")
            }));

            setVideos(videoData);
            setSelectedVideo(videoData[0]); // Set the first video as selected by default
        } catch (error) {
            console.error("Error fetching videos:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVideos(playlistId);
    }, [playlistId]);

    const handleVideoChange = (video) => {
        setSelectedVideo(video);
    };

    return (
        <div className="py-6">
            {/* Video Viewer */}
            <div className="video-viewer mb-8 flex flex-col gap-4">
                <div className="flex-1 rounded-2xl overflow-hidden">
                    {selectedVideo ? (
                        <iframe
                            className="aspect-video"
                            width="100%"
                            // height="500px"
                            src={`https://www.youtube.com/embed/${selectedVideo.id}`}
                            title={selectedVideo.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    ) : (
                        <div className="flex justify-center items-center h-full">
                            <Spin size="large" />
                        </div>
                    )}
                </div>
                {/* Playlist (removed, since it's not needed anymore) */}
                <div className="playlist max-w-full">
                    {loading ? (
                        <div className="flex justify-center items-center h-full">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <div className="flex flex-col space-y-6 max-h-[31rem] overflow-y-auto overflow-x-visible min-w-full">
                            {videos.map((video) => (
                                <Card
                                    key={video.id}
                                    hoverable
                                    bodyStyle={{
                                        padding: 0,
                                    }}
                                    className="shadow-lg transition-transform transform hover:bg-gray-300 w-full"
                                    onClick={() => handleVideoChange(video)} // Load selected video
                                >
                                    <div className="flex items-center space-x-4 px-2 py-4">
                                        {/* Thumbnail on the left */}
                                        <img
                                            alt={video.title}
                                            src={video.thumbnail}
                                            className="hidden md:inline-block w-40 object-cover rounded-l-md"
                                        />
                                        {/* Meta with title on the right */}
                                        <Meta
                                            title={
                                                <div className="truncate max-w-[calc(100%-3rem)]">{video.title}</div> // Title with ellipsis
                                            }
                                            description={video.publishedAt}
                                            className="flex-1 pr-4"
                                        />
                                    </div>
                                </Card>
                            ))}

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PlaylistList;
